<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_2" title="Title Page">J. B. Lightfoot<br/></h2>
<h1 class="sigil_not_in_toc">The Gospel of St. John</h1>
<h2 class="sigil_not_in_toc">A Newly Discovered Commentary</h2>
<h5 class="sigil_not_in_toc">The Lightfoot Legacy set</h5>
<p class="center"><img alt="49077.jpg" class="img10" src="Images/49077.jpg"/></p>
<p><br/></p>
<p class="center"><i>Volume 2</i></p>
<p><br/></p>
<h3 class="center sigil_not_in_toc"><i>Edited by</i></h3>
<p class="center">Ben Witherington III</p>
<p class="center"><i>and</i> Todd D. Still</p>
<h3 class="center sigil_not_in_toc"><i>Assisted by</i></h3>
<p class="center">Jeanette M. Hagen</p>
<div class="photo">
<a href="http://www.ivpress.com/academic" target="_blank"><img alt="IVP_Academic_Colophon.png" src="Images/IVP_Academic_Colophon.png"/></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?56573e6c